/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { SidebarTextField } from "~/components/SidebarForm/inputs/SidebarTextField";
import { SidebarForm } from "~/components/SidebarForm/SidebarForm";
import { SidebarFormButtons } from "~/components/SidebarForm/SidebarFormButtons";
import { showSuccess } from "~/components/Toast";
import { RouteParams } from "~/models";
import { ACTIONS, Can, ROUTES } from "~/routing";
import { generateActionSuccessText } from "~/tools";
import { useAxios } from "~/tools/hooks/useAxios";

function AssignmentRulesAdd() {
  const state = useParams<RouteParams>();
  const { customerId } = state;

  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const methods = useForm();
  const history = useHistory();

  const onSubmit = async (values: { name: string }) => {
    setIsSidebarOpen(false);
    try {
      const url = `/customers/${customerId}/assignmentRules`;
      const { data } = await Axios().post(url, values);
      history.push(
        `${ROUTES.customers.index}/${customerId}/assignment-rules/${data.id}/`
      );
      showSuccess(generateActionSuccessText(`Assignment Rule `)()(`added`)());
    } catch (e) {
      showError(e.response);
    }
  };

  return (
    <>
      <Can action={ACTIONS.ADD_CUSTOMER_ASSIGNMENT}>
        <Button
          onClick={() => setIsSidebarOpen(true)}
          css={{ marginLeft: "auto" }}
          icon="plus"
        >
          Add Assignment Rule
        </Button>
      </Can>

      <SidebarForm
        title="Add Assignment Rule"
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        formMethods={methods}
        submit={onSubmit}
      >
        <SidebarTextField name="name" label="Name" required />

        <SidebarFormButtons
          submitEnabled={!!methods.watch("name")}
          onCancel={() => setIsSidebarOpen(false)}
        />
      </SidebarForm>
    </>
  );
}

export { AssignmentRulesAdd };
